// extracted by mini-css-extract-plugin
export var icon = "_bi-3";
export var subtitle = "_bi-2";
export var title = "_bi-1";
export var value = "_bi-0";